export const RiskLevel = {
  LOW: 'LOW',
  LOW_MEDIUM: 'LOW_MEDIUM',
  HIGH_MEDIUM: 'HIGH_MEDIUM',
  HIGH: 'HIGH'
} as const

export type RiskLevel = (typeof RiskLevel)[keyof typeof RiskLevel]

export const RiskLevelLabel = {
  [RiskLevel.LOW]: 'Bajo',
  [RiskLevel.LOW_MEDIUM]: 'Medio Bajo',
  [RiskLevel.HIGH_MEDIUM]: 'Medio Alto',
  [RiskLevel.HIGH]: 'Alto'
} as const satisfies Record<RiskLevel, string>
